export default __webpack_public_path__ + "static/media/company_default.bc55c19a.png";